// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.powered-by-text-container[data-v-a6ba1180] {
  position: relative;
  padding-top: 20px;
}
.powered-by-text[data-v-a6ba1180] {
  position: absolute;
  right: 35.5%;
}`, "",{"version":3,"sources":["webpack://./src/Web/scripts/components/join-publication/JoinPublicationExistingUser.vue","webpack://./JoinPublicationExistingUser.vue"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,iBAAA;ACDF;ADGA;EACE,kBAAA;EACA,YAAA;ACAF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.powered-by-text-container {\n  position: relative;\n  padding-top: 20px;\n}\n.powered-by-text {\n  position: absolute;\n  right: 35.5%;\n}\n",".powered-by-text-container {\n  position: relative;\n  padding-top: 20px;\n}\n\n.powered-by-text {\n  position: absolute;\n  right: 35.5%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
